<app-form-generator
    [formGeneratorInput]="credentialsFormGenInput"
    (formGroupRef)="credentialsFormGroup = $event"
></app-form-generator>
